<template>
  <div class="tenders__options">
    <div class="tenders__options-option m-b-20">
      <template v-for="tender in tenders" :key="tender.name">
        <div class="tenders__options-radio p-t-20 p-b-20">
          <app-radio-button
            :id="tender.name"
            :label="tender.buttonText || tender.name"
            :group-name="groupName"
            :modelValue="String(tender.paymentType)"
            :payload="tender.name"
            @onChangeHandler="onChangeHandler"
          />
        </div>
        <div v-if="tender.name === selectedPayType" :key="tender.paymentType" class="tenders__options-content">
          <tender-card-input
            :name="tender.name"
            :payment-type="tender.paymentType"
            :subpayment-type="tender.subpaymentType"
            :button-text="tender.buttonText"
            @cardApplied="cardApplied"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TenderCardInput from "./TenderCardInput";
export default {
  name: "Tenders",
  components: {
    TenderCardInput
  },
  props: {
    groupName: String,
    payload: String,
    selectedPayType: String
  },
  computed: {
    ...mapGetters({
      tenders: "vendor/getTenders"
    })
  },
  data() {
    return {};
  },
  methods: {
    cardApplied() {
      this.$emit("cardApplied");
    },
    onChangeHandler(event) {
      this.$emit("onChangeHandler", event);
    }
  }
};
</script>

<style scoped lang="scss">
.tenders {
  font-family: $fontFamilySecondary;
  order: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__options {
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;

    &-option {
      font-weight: bold;
      display: flex;
      flex-direction: column;
    }

    &-radio {
      display: flex;
      background-color: $primary-color;

      img {
        margin: 0 4px -3px 0;
        width: 1.3em;
      }
    }

    &-content {
      border-radius: 5px;
      background: $group-3-color-3-alpha-08;
    }
  }
}
</style>
